import React, { Dispatch, SetStateAction, useEffect, useRef } from "react"
import tw, { css, styled, theme } from "twin.macro"
import ReactModal from "react-modal"
import "twin.macro"
import { ReactComponent as CloseSVG } from "../../assets/icons/close-black.svg"
import { useStopBodyScroll } from "../../utils/hooks/useStopBodyScroll"

interface ModalProps {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  onAfterClose?: () => void
  component: JSX.Element
  notDismissable?: boolean
}

const StyledOverlay = styled("div")(() => [tw`z-20 !bg-overlay `])

const StyledModal = styled("div")(() => [
  tw`!top-1/2 !left-1/2 transform -translate-y-1/2 -translate-x-1/2 !p-0 !bg-modal shadow-base-2 !border-2 !border-base-1 !border-solid !rounded-lg !bg-background w-[90%]`,
  css`
    @media (min-width: ${theme`screens.mobile-lg`}) {
      ${tw`min-w-[358px]`}
      width: fit-content;
      max-height: calc(100vh - 4rem);
    }
    height: fit-content;
  `,
])

export const Modal = (props: ModalProps) => {
  const { show, setShow, component, notDismissable, onAfterClose } = props
  useStopBodyScroll(show)
  const loaded = useRef(false)
  useEffect(() => {
    loaded.current = true
  }, [])

  return (
    <>
      {loaded.current && (
        <ReactModal
          appElement={document.body}
          isOpen={show}
          onRequestClose={() => setShow(false)}
          onAfterClose={onAfterClose}
          shouldCloseOnEsc={notDismissable ? false : true}
          shouldCloseOnOverlayClick={notDismissable ? false : true}
          contentElement={(props, children) => (
            //flex box around children breaks carousel render, should control contents in child components
            <StyledModal {...props}>{children}</StyledModal>
          )}
          overlayElement={(props, contentElement) => <StyledOverlay {...props}>{contentElement}</StyledOverlay>}
          testId="bonsai-modal"
        >
          {!notDismissable && (
            <button onClick={() => setShow(false)} tw="absolute cursor-pointer top-3.5 right-3.5">
              <CloseSVG tw="w-4 h-4" />
            </button>
          )}
          <div tw="px-3.5 py-10 mobile-lg:px-12">{component}</div>
        </ReactModal>
      )}
    </>
  )
}
